import React, { useMemo } from 'react';

import { styled } from '@mui/material/styles';
import { useContainer } from 'unstated-next';

import { AddSessionsFields, type AddSessionsFieldsProps } from '../../../../components/addSessions/AddSessionsFields';
import { type AttendanceType } from '../../../../components/addSessions/types';
import { calcSessions } from '../../../../components/addSessions/utils/calcSessions';
import { type ClassStudentGroupSet, type ClassSessionInfo, type ClassStudentGroup } from '../../../../context/types';
import { ClassContainer } from '../../ClassContainer';

const SessionsContainer = styled('div')`
    margin: 0 0 1rem 0;
`;

interface DateProps {
    index: number;
    isLastIndex: boolean;
    classGroups?: ClassStudentGroup[] | undefined;
    classGroupSets?: ClassStudentGroupSet[] | undefined;
    classSessions?: ClassSessionInfo[] | undefined;
    classSessionGroupUuid?: string;
    label?: string;
    selectedGroups?: string[];
    attendanceType?: AttendanceType;
}

export const Date = (props: DateProps) => {
    const {
        isLastIndex,
        index,
        classGroups,
        classGroupSets,
        classSessionGroupUuid,
        label,
        selectedGroups,
        attendanceType
    } = props;
    const { control, addDefaultDate, removeDate, dateFields, lmsSyncSettings } = useContainer(ClassContainer);

    const date = useMemo(() => dateFields[index], [dateFields, index]);
    const { isOvernight } = useMemo(() => calcSessions(date), [date]);

    const addSessionsFieldsProps: AddSessionsFieldsProps = useMemo(() => {
        const values: AddSessionsFieldsProps = {
            namePrefix: `dates.${index}.`,
            control,
            isOvernight,
            classGroups,
            classGroupSets,
            classSessionGroupUuid,
            label,
            selectedGroups,
            attendanceType,
            lmsSyncSettings
        };

        if (isLastIndex) {
            values.onAddMore = addDefaultDate;
        }

        if (index !== 0) {
            values.onClose = () => removeDate(index);
        }

        return values;
    }, [
        index,
        control,
        isOvernight,
        classGroups,
        classGroupSets,
        classSessionGroupUuid,
        label,
        selectedGroups,
        attendanceType,
        lmsSyncSettings,
        isLastIndex,
        addDefaultDate,
        removeDate
    ]);

    return (
        <SessionsContainer>
            <AddSessionsFields {...addSessionsFieldsProps} />
        </SessionsContainer>
    );
};
